module.exports = __webpack_public_path__ + "static/media/officems.0bd8fed2.jpg";